import { render, staticRenderFns } from "./inventoryStockMonthlyUsageChartWidget.vue?vue&type=template&id=fac98c3e&"
import script from "./inventoryStockMonthlyUsageChartWidget.vue?vue&type=script&lang=js&"
export * from "./inventoryStockMonthlyUsageChartWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports